import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LoginForm from '../../components/LoginForm';
import './AuthPages.css';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/resume';

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Sign in</h1>
        <p className="auth-card__lead">Use the account an administrator has approved.</p>
        <LoginForm
          inputIdPrefix="login-page"
          onLoggedIn={() => navigate(from, { replace: true })}
          extraActions={
            <>
              <Link to="/forgot-password">Forgot password?</Link>
              <Link to="/register">Request access (register)</Link>
            </>
          }
        />
      </div>
    </div>
  );
}
